<div class="input-search" [class.input-search--disabled]="disabled">
  <i class="fas fa-search input-search__icon"></i>
  <input
    #searchInput
    type="text"
    class="input-search__input"
    [placeholder]="placeholder"
    [required]="required"
    [disabled]="disabled"
    [attr.maxlength]="maxLength"
    [attr.tabindex]="focusable ? null : -1"
    [value]="inputValue"
    (input)="onInput($event)"
  />
  <button
    *ngIf="inputValue"
    type="button"
    class="input-search__clear"
    [disabled]="disabled"
    (click)="clear()"
  >
    <i class="fas fa-times"></i>
  </button>
</div>
